<template>
  <div class="container event__content-container">
    <EventInfo class="event__content-card" :event-id="eventId" />
    <EventCalendar class="event__content-card" id="event-calendar" />
    <EventCompanyProfile
      id="event-company-profile"
      class="event__content-card"
    />

    <EventUsers id="event-users" class="event__content-card" />
    <EventPasses
      :event-id="eventId"
      id="event-passes"
      class="event__content-card passes"
    />
  </div>
</template>
<script>
import EventInfo from "@/components/Custom/EventInfo.vue";
import EventPasses from "@/components/Custom/EventPasses.vue";
import { mapGetters } from "vuex";
import EventCompanyProfile from "@/components/Custom/EventCompanyProfile.vue";
import EventUsers from "@/components/Custom/EventUsers.vue";
import EventCalendar from "@/components/Custom/EventCalendar.vue";

export default {
  name: "ParticipantSpecialProject",

  components: {
    EventCalendar,
    EventUsers,
    EventCompanyProfile,
    EventPasses,
    EventInfo
  },
  computed: {
    ...mapGetters("event", ["eventId", "isServiceShown"])
  }
};
</script>
